import { twMerge } from 'tailwind-merge';
import { classes } from './utils';

export default function DialogActions({ className = '', ...props }) {
  return (
    <div className={twMerge(className, classes.dialogActions)} {...props} />
  );
}
